import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { Store } from 'lucide-react';
const Marketplace = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-3167">
      <div className="w-20 flex-shrink-0" data-id="element-3168">
        <Sidebar data-id="element-3169" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3170">
        <Topbar data-id="element-3171" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-3172">
          <PageHeader title="Marketplace" subtitle="Gestione marketplace e catalogo premi" data-id="element-3173" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-3174">
            <div className="text-center" data-id="element-3175">
              <Store className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-3176" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-3177">
                Marketplace
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-3178">
                Questa pagina conterrà il marketplace. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Marketplace;